import React from "react"
import FlexibleCommunicationImage from "../../../../../components/staticQuery/platform/automation/FlexibleCommunicationImage"
import P from "../../../../../components/typography/P"
import ClickGraphic from "../../../../../images/platform/automation/click.svg"

const DescriptionText = () => (
  <>
    <P>
      Marketing Automation with Email or Text alone is so yesterday. Now you can
      send Email and Text Messages right in your Sequences. And you can improve
      deliverability with built-in Smart Reminders and Text Replacement when an
      Email is not available.
    </P>
  </>
)

const flexibleCommunciationData = {
  titleIcon: ClickGraphic,
  title: "Flexible Communication",
  description: <DescriptionText />,
  graphic: <FlexibleCommunicationImage />,
  // imageLeft: false,
  textLong: false,
  benefits: [],
}

export default flexibleCommunciationData
